import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { useAbortedEffect, useHookForm } from "../../../components/hooks";
import { DangerousAPI } from "../../../axios/api";

import ModuleBreadCrumb from "../../../components/breadCrumb";
import ModuleTitle from "../../../components/common/title";
import { FormCheckbox, FormInputtext } from "../../../components/formElement";
import { formatResData, checkFormUpdate } from "../../../service/common";
import {
  option_category_obj,
  option_dangerous_eat_type,
  option_dangerous,
} from "../../../service/option";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";

export default function MemberSettingDangerous() {
  const dispatch = useDispatch();
  const redux_user = useSelector((state) => state.user);
  const crumbItem = [
    { key: 1, label: "首頁", href: "/member" },
    { key: 2, label: "系統相關", href: "/member/setting" },
    { key: 3, label: option_category_obj.setting.dangerous.label },
  ];
  const [reload, setReload] = useState({ list: true });
  const [apiData, setApiData] = useState({});
  const disabled = true;
  // 表單欄位預設值
  const defaultValues = {
    r1: false,
    r2: false,
    r3: false,
    r4: false,
    r5: false,
    r6: false,
    r7: false,
    r8: false,
    r8_1: false,
    r8_2: false,
    r8_3: false,
    r8_4: false,
    r9: false,
    r10: false,
    r11: false,
    r12: false,
    r12_other: "",
  };
  const {
    handleSubmit,
    getValues,
    reset,
    setValue,
    trigger,
    watch,
    yup,
    setSchema,
    errors,
    setting,
  } = useHookForm({
    defaultValues,
  });
  // 監聽欄位
  const watchColumn = {
    data: watch("r8"),
  };

  useEffect(() => {
    setSchema(yup.object({}).required());
  }, []);

  // 動態判斷欄位
  useEffect(() => {
    let submitData = getValues();

    if (!submitData.r8) {
      setValue("r8_1", false);
      setValue("r8_2", false);
      setValue("r8_3", false);
      setValue("r8_4", false);
      trigger(["r8_1", "r8_2", "r8_3", "r8_4"]);
    }
  }, [watchColumn.data]);

  useAbortedEffect(
    (signal) => {
      if (!reload.list) return;

      dispatch(setProgress(true));

      DangerousAPI.getMyRisk_factorsByMemberid({
        options: { signal },
      }).then((result) => {
        let { Response, data, message } = result;

        if (Response === 1) {
          if (!data) data = {};

          [...option_dangerous, ...option_dangerous_eat_type].forEach(
            (item) => {
              data[item.key] = data[item.key] === 1;
            }
          );

          let temp = formatResData(defaultValues, data);
          setApiData(data);
          reset(temp);
          setReload((state) => ({ ...state, list: false }));
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }

        dispatch(setProgress(false));
      });
    },
    [reload]
  );

  const onSubmit = (submitData) => {
    dispatch(setProgress(true));

    let jsonData = {
      ...submitData,
      memberid: redux_user.userDetail.id,
    };
    [...option_dangerous, ...option_dangerous_eat_type].forEach(
      (item) => (jsonData[item.key] = jsonData[item.key] ? 1 : 0)
    );

    if (!checkFormUpdate(jsonData, apiData)) {
      dispatch(
        setToast({
          severity: "warn",
          summary: "無資料變更",
          detail: "",
        })
      );
      dispatch(setProgress(false));
      return;
    }

    let promise,
      toast = "";
    if (!apiData.id) {
      // 新增
      promise = DangerousAPI.setRisk_factors({
        data: jsonData,
      });
      toast = "新增";
    } else {
      // 修改
      jsonData.id = apiData.id;
      promise = DangerousAPI.updateRisk_factors({
        data: jsonData,
      });
      toast = "編輯";
    }

    promise.then((result) => {
      let { Response, message } = result;

      if (Response === 1) {
        dispatch(
          setToast({
            severity: "success",
            summary: `${toast}成功`,
            detail: "",
          })
        );
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: `${toast}失敗`,
            detail: message ?? "",
          })
        );
      }
      dispatch(setProgress(false));
    });
  };

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <ModuleTitle
        data={{ title: option_category_obj.setting.dangerous.label }}
      />

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-column align-items-start sm:flex-row field col-12 py-0 mb-0">
          <label
            htmlFor="data"
            className={classNames(
              { "p-error": errors.data },
              "col-12 sm:col-3 text-left sm:text-right -mb-1 sm:mb-0"
            )}
          >
            {/* <span className="text-red-400 mr-1">*</span> */}
            危險因素
          </label>
          <div className="flex flex-column col-12 sm:col-9">
            {option_dangerous.map((dangerous, dIdx) => (
              <div
                key={`dangerous_${dangerous.value}`}
                className={classNames({
                  "mt-3": dIdx !== 0,
                })}
              >
                <div className="flex flex-column md:flex-row">
                  <FormCheckbox
                    className="flex justify-content-start m-0"
                    setting={setting}
                    data={{
                      name: dangerous.key,
                      label: dangerous.label,
                      value: true,
                      type: "checked",
                      disabled,
                    }}
                  />

                  {dangerous.key === "r8" && (
                    <div className="flex flex-wrap align-items-center mt-3 ml-4 md:mt-0 md:ml-0">
                      <span className="mr-2">{`(`}</span>
                      {option_dangerous_eat_type.map((eat) => (
                        <FormCheckbox
                          className="flex justify-content-start m-0 mr-2 my-1 md:my-0"
                          setting={setting}
                          data={{
                            name: eat.key,
                            label: eat.label,
                            value: true,
                            type: "checked",
                            disabled: !getValues("r8") || disabled,
                          }}
                        />
                      ))}
                      {`)`}
                    </div>
                  )}

                  {dangerous.key === "r12" && getValues("r12") && (
                    <FormInputtext
                      className="md:ml-2 mt-2 md:mt-0"
                      setting={setting}
                      data={{
                        name: "r12_other",
                        placeholder: "其他危險因素",
                        disabled: !getValues("r12") || disabled,
                      }}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {!disabled && (
          <div className="w-full text-right mt-3 pr-3">
            <Button className="ml-4 px-4" type="submit" label="儲存" />
          </div>
        )}
      </form>
    </>
  );
}
